
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// import 'react-dropzone-component/styles/filepicker.css'
import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { Box, Icon, IconButton, Modal, Typography } from "@mui/material";
import { adminResetUserPassword, getUUIDFromKey } from "utils/helpers";
import Alert from "components/Alert";
import { MenuPopover } from "components/MenuPopover";
import { Table } from "types";
import { useNavigate } from "react-router-dom";
import { adminDeleteUser, getUsers } from "services/user-services";
import { useAppContext } from "context/app-context";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";


// interface CardType {
//   PK: string
//   name: string
//   subject: string
//   grade: string
//   isShared: boolean
// }

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  maxHeight: 'calc(100vh - 100px)',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function Analytics(): JSX.Element {
  const navigate = useNavigate()
  // const [pk, setPk] = useState<string>('')
  const [data, setData] = useState({} as Table)
  // const [card, setCard] = useState({} as CardType)
  const [dataTableData, setDataTableData] = useState<null | Table>(null)
  const [open, setOpen] = useState(false)
  const [newPassword, setNewPassword] = useState('')
  const [pk, setPk] = useState('')

  const handleGenerateNewPassword = () => {
    const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let password = ''
    for (let i = 0; i < 10; i++) {
      password += alphabet[Math.floor(Math.random() * alphabet.length)]
    }
    setNewPassword(password)
  }

  const handleSubmit = async () => {
    await handleResetPassword(getUUIDFromKey(pk), newPassword)
  }


  function getRole(role: string):string {
    switch (role) {
      case 'ADMIN':
        return 'Administrator'
      case 'TEACHER':
        return 'Lærer'
      case 'STUDENT':
        return 'Elev'
      default:
        return 'Ukendt'
    }
  }

  useEffect(() => {
    (async () => {
      setDataTableData({
        columns: [
          { Header: "Handlinger", accessor: "actions", width: "10%" },
          { Header: "Navn", accessor: "name", width: "30%" },
          { Header: "E-mail", accessor: "email", width: "20%" },
          { Header: "Rolle", accessor: "role", width: "10%" },
          { Header: "Abonnements id", accessor: "subscriptionId", width: "10%"},
          { Header: "Dato for oprettelse", accessor: "createdAt", width: "10%" },
          { Header: "Sidst opdateret", accessor: "updatedAt", width: "10%" },
        ], rows: (await getUsers()).map(user => ({
          ...user,
          role: getRole(user.role),
          createdAt: new Intl.DateTimeFormat("da-DK", { month: 'short', day: '2-digit', year: 'numeric' }).format(user.createdAt),
          updatedAt: new Intl.DateTimeFormat("da-DK", { month: 'short', day: '2-digit', year: 'numeric' }).format(user.updatedAt),
        }))
      })
    })()
  }, [])


  const handleResetPassword = async (id: string, password: string) => {
      try {
          await adminResetUserPassword(id, password)
          return true
      } catch (error) {
          return false
      }
  }


  const handleDelete = (card: { [key: string]: any; }) => {
    warningWithConfirmAndCancelMessage(card.PK)
  }

  useEffect(() => {
    if (dataTableData) {
      setData({
        ...dataTableData, rows: dataTableData.rows.map((dt) => ({
          ...dt,
          actions: (
            <>
              <MenuPopover
                menuEntries={[
                  {
                    icon: 'lock_reset',
                    text: 'Nulstille kodeord',
                    onClick: () => { setOpen(true); setPk(dt.PK)}
                  },
                  {
                    icon: 'pie_chart',
                    text: 'Info',
                    onClick: () => seeInfoUser(getUUIDFromKey(dt.PK))
                  },
                  {
                    icon: 'delete',
                    text: 'Slet',
                    onClick: () => handleDelete(dt)
                  }
                ]}
              />
            </>
          ),
          // name: dt.name,
          removeLink: (
            <IconButton key={dt.title} onClick={async () => await warningWithConfirmAndCancelMessage(dt.PK)}><Icon fontSize="small">delete</Icon></IconButton>
          )
        })
        )
      })
    }
  }, [dataTableData])

  const { handleMessage } = useAppContext()
  
  const handleDeleteUser = async (userId: string) => {
    try {
      await adminDeleteUser(getUUIDFromKey(userId))
      setDataTableData({
        ...dataTableData, rows: dataTableData.rows.filter(dt => dt.PK !== userId)
      })
      success()
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }

  }
  const [alert, setAlert] = useState(null)

  const hideAlert = () => {
    setAlert(null);
  };
  const success = (type = 'archive') => {
    setAlert(
      //@ts-ignore
      <Alert
        success
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Slettet!'
        confirmBtnText='Okay'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle='success'
        btnSize=''
      > Dit kort blev fjernet...</Alert>
    );
  };
  const cancel = () => {
    setAlert(
      <Alert
        danger
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Aflyst'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnText='Okay'
        confirmBtnBsStyle='success'
        btnSize=''
      ></Alert>
    );
  };
  const warningWithConfirmAndCancelMessage = (id: string) => {
    setAlert(
      //@ts-ignore
      <Alert
        warning
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Er du sikker?'
        onConfirm={async () => {
          await handleDeleteUser(id);
        }}
        onCancel={() => cancel()}
        confirmBtnBsStyle='success'
        cancelBtnBsStyle='danger'
        confirmBtnText='Ja, slet!'
        cancelBtnText='Annullér'
        showCancel
        btnSize=''
      > Er du sikker på, at du vil slette denne kortsamling?
      </Alert>
    );
  };
  const seeInfoUser = async (userId: string) => { // @ts-ignore
    navigate(`/user/${userId}`)
  }

  return (
    <DashboardLayout>
      <Modal
        open={open}
        onClose={() => setOpen(!open)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Nulstil kodeord
          </Typography>
          <MDBox pr={1} mt={2.5}>
            <MDInput sx={{ minWidth: 300}} fullWidth value={newPassword} onChange={(e: any) => setNewPassword(e.target.value)} label='Nyt kodeord' />
          </MDBox>
          <MDBox pr={1} mt={2.5} justifyContent='space-between' display='flex'>
            <MDButton onClick={handleSubmit} color='success' >
              Gem
            </MDButton>
            <MDButton onClick={handleGenerateNewPassword} color='info' >
              Generer kode
            </MDButton>
          </MDBox>
        </Box>
      </Modal>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        {alert}
        <Card>
          <MDBox p={3} lineHeight={1}>
            <MDTypography variant="h5" fontWeight="medium">
              Analytics
            </MDTypography><br />
            <MDTypography variant="h6">
              Her er en oversigt over brugerne i appen
            </MDTypography>
            <MDTypography variant="h6">
              Klik på "handlinger" for at administrere brugerne
            </MDTypography>
          </MDBox>
          {Object.keys(data).length ? <DataTable table={data} canSearch /> : null}
        </Card>
      </MDBox >
    </DashboardLayout >
  );
}

export default Analytics;
